import { isProd, isDev } from '../../app/utils/environment';

export const isDevelopment = () => isDev();
export const isProduction = () => isProd();

export default () => (isProd() ? 'production' : 'development');
